import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Servizio} from "../models/servizio";

@Injectable({
  providedIn: 'root'
})
export class AppuntamentiService {
  url = "services/portalenextappointment/api";
  urlNextApp = "services/nextappointment/api"
  constructor(private httpClient: HttpClient) { }
  eliminaAppuntamentoAPI(form: any){
    return this.httpClient.get<any>(this.url + "?s=" + encodeURIComponent(JSON.stringify(form)));
  }

  datiServizioAPI(form: any): Observable<any> {
    return this.httpClient.get<any>(this.url + "/pn-servizio/search?s=" + encodeURIComponent(JSON.stringify(form)));
  }

  modificaServizioApi(form: any): Observable<any> {
    return this.httpClient.patch<any>(this.urlNextApp + "/na-servizi-erogati/updatep", form);
  }

  getServizi(form: any): Observable<any> {
    return this.httpClient.get<any>(this.urlNextApp + "/na-servizi-erogati/searchAllServizi?s=" + encodeURIComponent(JSON.stringify(form)));
  }
  ricercaTuttiAppuntamentiAPI(): Observable<any>{
    return this.httpClient.get<any>(this.urlNextApp + "/na-appuntamento/getAll");
  }

  getAllUfficiAPI(): Observable<any>{
    return this.httpClient.get<any>(this.urlNextApp + "/na-ufficio/getAll")
  }
  getAllSediAPI(): Observable<any>{
    return this.httpClient.get<any>(this.urlNextApp + "/na-sede/getAll")
  }
  ricercaTuttiServiziApi(): Observable<Servizio[]> {
    return this.httpClient.get<Servizio[]>("services/nextappointment/api/na-servizio/getAll");
  }
  insertServiceAPI(form: any): Observable<any>{
    return this.httpClient.post<any>(this.urlNextApp + "/na-servizio/insert", form)
  }

  inserimentoServizioErogatoAPI(form: any): Observable<any>{
    return this.httpClient.post<any>(this.urlNextApp + "/na-servizi-erogati/insert", form)
  }
}
